import { SidingType, SidingArea, SidingColor } from "./colors";

let imgBaseUrl = process.env.PUBLIC_URL + "/img";

let HOUSE_URL = `${imgBaseUrl}/KlauerHouse.png`;
let TRIM_URL = `${imgBaseUrl}/KlauerHouse_Trim.png`;
let sidingUrlFor = (sidingType: SidingType, sidingArea: SidingArea) => {
    var type = sidingType === SidingType.SelectSiding ? SidingType.DutchLap : sidingType;
	return `${imgBaseUrl}/${SidingArea[sidingArea]}/KlauerHouse_${SidingType[type]}${SidingArea[sidingArea]}.png`;
};

let trimUrlFor = (color: SidingColor) => {
	return `${imgBaseUrl}/Trim/${SidingColor[color]}.png`;
};

let urlFor = (file: string) => {
	return `${imgBaseUrl}/${file}`;
}

export { HOUSE_URL, TRIM_URL, sidingUrlFor, urlFor, trimUrlFor }
